import { AdminOrManagerRoute } from "@shared/guards/RoleBasedGuards";
import UsersList from "@/features/users/UsersList";
import Account from "@/features/users/Account";
import UsersPage from "@features/users/pages/users-page";
import CreateUserPage from "@features/users/pages/create-user-page";

export const usersRoutes = {
  path: "/users",
  element: (
    <AdminOrManagerRoute>
      <UsersPage />
    </AdminOrManagerRoute>
  ),
  children: [
    {
      path: "/users",
      element: <UsersList />,
    },
    {
      path: "/users/create",
      element: (
        <AdminOrManagerRoute>
          <CreateUserPage />
        </AdminOrManagerRoute>
      ),
    },
    { path: "/users/:id", element: <Account /> },
  ],
};
